// deps
import React, { memo, ReactElement, useCallback, useMemo } from "react";

//components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { AmountBoxContainer, AmountBoxTextContainer, MostPopularText } from "./styles";

//defs
import { AmountBoxData } from "@core-ui/interfaces/AmountWidget";

import styles from "./AmountBox.v4.scss";

//constants
import { MOST_POPULAR_TEXT, AMOUNT_BOX_ID } from "@core-ui/constants/AmountBox";

//helpers
import { getAmountBoxAriaLabel } from "@core-ui/helpers/Utils";
import { format } from "@core-ui/utils/String";

const AmountBox = ({
    selected,
    text,
    boxAmount,
    onAmountBoxSelection,
    dataTestIds,
    showMostPopularText,
}: AmountBoxData): ReactElement => {
    const accessibilityId = useMemo(() => format(AMOUNT_BOX_ID, text), [text]);

    const onClickCallBack = useCallback(() => {
        typeof onAmountBoxSelection === "function" && onAmountBoxSelection({ amount: boxAmount, selected: !selected });
        document?.getElementById(accessibilityId)?.focus();
    }, [onAmountBoxSelection, boxAmount, selected, accessibilityId]);

    const testId = selected ? dataTestIds.selected : dataTestIds.default;

    const amountBoxAriaLabel = useMemo(() => getAmountBoxAriaLabel(text, selected, showMostPopularText), [
        selected,
        showMostPopularText,
        text,
    ]);

    return (
        <AmountBoxContainer
            selected={selected}
            id={accessibilityId}
            data-testid={testId}
            onClick={onClickCallBack}
            aria-label={amountBoxAriaLabel}
        >
            <AmountBoxTextContainer as="span" mostPopular={showMostPopularText} aria-hidden="true">
                <Text
                    variant={selected ? "V2.body2.neutral.bold" : "V2.body2.neutral.medium"}
                    color={selected ? "primary" : "text_High_Emphasis"}
                    className={styles.rupee}
                >
                    {text}
                </Text>
                {showMostPopularText && (
                    <>
                        <MostPopularText variant="V2.caption.neutral.medium" color="text_Button_Primary">
                            {MOST_POPULAR_TEXT}
                        </MostPopularText>
                    </>
                )}
            </AmountBoxTextContainer>
        </AmountBoxContainer>
    );
};

export default memo(AmountBox);
